/**
 * DTO enum for project changed field names
 * Maps to backend ProjectChangedField enum
 */
export enum ProjectChangedFieldNameDTO {
  STATUS = 'STATUS',
  TENTATIVE_PROBABILITY = 'TENTATIVE_PROBABILITY',
  MANAGER_USER = 'MANAGER_USER',
  PROJECT_START_DATE = 'PROJECT_START_DATE',
  PROJECT_END_DATE = 'PROJECT_END_DATE',
  INDUSTRIES = 'INDUSTRIES',
  CUSTOM_ATTRIBUTES = 'CUSTOM_ATTRIBUTES',
  BILLING_MODEL = 'BILLING_MODEL',
  DEFAULT_CURRENCY_CODE = 'DEFAULT_CURRENCY_CODE',
  BUDGET = 'BUDGET',
  RATE_SOURCE = 'RATE_SOURCE',
  FLAT_RATE = 'FLAT_RATE',
  USER_RATES = 'USER_RATES',
  USER_CUSTOM_RATE = 'USER_CUSTOM_RATE',
  USER_RATE_SOURCE = 'USER_RATE_SOURCE',
  RATE_CARD = 'RATE_CARD',
  GOOGLE = 'GOOGLE',
  JIRA = 'JIRA',
  QUICK_BOOKS = 'QUICK_BOOKS',
  UNKNOWN = 'UNKNOWN',
}
